<template>
  <router-view />
</template>
<style lang="scss">
  html, body, #q-app {
    height: 100%;
  }
</style>